import { useCallback, useState } from "react";
import ReactDOM from "react-dom";
import { C } from "../../shared/theme";
import { ConfirmDialog } from "../../shared/ConfirmDialog";
import { UndoToast } from "../today/UndoToast";

// The circle that finishes a task, on every list of tasks: Goals, Tasks, Today and a goal's own page. It asks
// first, so a slip of the thumb doesn't finish a task (Craig, 21 Oct 2026; on Today too, 22 Oct 2026).
// `done` fills it. onDone() and onUndo() save and return a promise; a failed save says so along the bottom of
// the screen. Without onUndo a filled circle does nothing: the task is unfinished from its editor.
// The circle sits 11px into the row's left padding, so its 44px tap area doesn't move the row's text; `style`
// adjusts that for a row with other spacing.
export function DoneCheck({ text, done, onDone, onUndo, style }) {
  const [asking, setAsking] = useState(false);
  const [failed, setFailed] = useState(false);
  const clearFailed = useCallback(() => setFailed(false), []);
  const save = (write) => {
    setFailed(false);
    write().catch(e => { console.error("Saving the task failed:", e); setFailed(true); });
  };
  const tap = () => {
    if (!done) setAsking(true);
    else if (onUndo) save(onUndo);
  };
  return (
    <>
      <button onClick={(e) => { e.stopPropagation(); tap(); }} aria-label={done ? `Mark "${text}" not done` : `Mark "${text}" done`}
        aria-haspopup={done ? undefined : "dialog"} aria-disabled={done && !onUndo ? true : undefined}
        style={{ width: 44, height: 44, flexShrink: 0, marginLeft: -11, display: "flex", alignItems: "center", justifyContent: "center", padding: 0, background: "none", border: "none", cursor: done && !onUndo ? "default" : "pointer", ...style }}>
        <span aria-hidden="true" style={{ width: 22, height: 22, borderRadius: "50%", border: `2px solid ${done ? C.accent : C.border}`, background: done ? C.accent : "transparent", display: "flex", alignItems: "center", justifyContent: "center", transition: "background 0.15s" }}>
          {done && <svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke={C.onAccent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="2,6 5,9 10,3" /></svg>}
        </span>
      </button>
      {asking && (
        <ConfirmDialog title="Have you finished this task?" body={text} confirm="Yes, it's done" cancel="Not yet"
          onConfirm={() => { setAsking(false); save(onDone); }} onCancel={() => setAsking(false)} />
      )}
      {/* In a portal: a dragged row's transform would otherwise pin the message to the row. */}
      {failed && ReactDOM.createPortal(
        <UndoToast message="We couldn't save that task. Check your connection and try again." onDone={clearFailed} />,
        document.body
      )}
    </>
  );
}
